(function () {
  if (customElements.get('home-fourth-steps')) return;

  class HomeFourthSteps extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.home-fourth__track');
      this.steps = Array.from(this.querySelectorAll('.home-fourth__step'));
      if (!this.track || this.steps.length === 0) return;

      this.activeIndex = -1;
      this.ticking = false;
      this.scrollModeActive = false;
      this.manualScroll = false;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onSummaryClick = this.onSummaryClick.bind(this);
      this.onMotionChange = this.onMotionChange.bind(this);

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopQuery = window.matchMedia('(min-width: 990px)');

      if (this.motionQuery.addEventListener) {
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.desktopQuery.addEventListener('change', this.onMotionChange);
      } else {
        this.motionQuery.addListener(this.onMotionChange);
        this.desktopQuery.addListener(this.onMotionChange);
      }

      this.steps.forEach((step) => {
        const summary = step.querySelector('.home-fourth__summary');
        summary?.addEventListener('click', this.onSummaryClick);
      });

      this.refreshMode();
    }

    disconnectedCallback() {
      this.disableScrollMode();

      if (this.motionQuery?.removeEventListener) {
        this.motionQuery.removeEventListener('change', this.onMotionChange);
        this.desktopQuery.removeEventListener('change', this.onMotionChange);
      } else if (this.motionQuery?.removeListener) {
        this.motionQuery.removeListener(this.onMotionChange);
        this.desktopQuery.removeListener(this.onMotionChange);
      }

      this.steps?.forEach((step) => {
        const summary = step.querySelector('.home-fourth__summary');
        summary?.removeEventListener('click', this.onSummaryClick);
      });
    }

    onMotionChange() {
      this.refreshMode();
    }

    refreshMode() {
      const shouldScroll =
        !window.Shopify?.designMode &&
        this.desktopQuery.matches &&
        !this.motionQuery.matches &&
        this.steps.length > 1;

      if (shouldScroll) {
        this.enableScrollMode();
        this.updateActiveStep();
      } else {
        this.disableScrollMode();
      }
    }

    enableScrollMode() {
      if (this.scrollModeActive) return;

      this.scrollModeActive = true;
      this.classList.add('home-fourth--scroll-steps');
      this.style.setProperty('--home-fourth-step-count', String(this.steps.length));

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disableScrollMode() {
      if (!this.scrollModeActive && !this.classList.contains('home-fourth--scroll-steps')) return;

      this.scrollModeActive = false;
      this.classList.remove('home-fourth--scroll-steps');
      this.activeIndex = -1;

      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);

      if (this.steps[0] && !this.steps.some((step) => step.open)) {
        this.setActiveStep(0, { force: true });
      }
    }

    onScroll() {
      if (!this.scrollModeActive || this.manualScroll) return;

      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.updateActiveStep();
        this.ticking = false;
      });
    }

    onResize() {
      this.refreshMode();
      if (this.scrollModeActive) this.updateActiveStep();
    }

    getProgress() {
      const trackTop = this.track.getBoundingClientRect().top + window.scrollY;
      const scrollable = Math.max(1, this.track.offsetHeight - window.innerHeight);
      const progress = (window.scrollY - trackTop) / scrollable;
      return Math.min(1, Math.max(0, progress));
    }

    updateActiveStep() {
      if (!this.scrollModeActive) return;

      const progress = this.getProgress();
      const index = Math.min(
        this.steps.length - 1,
        Math.floor(progress * this.steps.length)
      );

      this.setActiveStep(index);
    }

    setActiveStep(index, { force = false } = {}) {
      if (!force && index === this.activeIndex) return;
      if (index < 0 || index >= this.steps.length) return;

      this.activeIndex = index;

      this.steps.forEach((step, stepIndex) => {
        if (stepIndex === index) {
          if (!step.open) step.open = true;
        } else if (step.open) {
          step.open = false;
        }
      });
    }

    onSummaryClick(event) {
      if (!this.scrollModeActive) return;

      event.preventDefault();

      const step = event.currentTarget.closest('.home-fourth__step');
      const index = this.steps.indexOf(step);
      if (index < 0) return;

      this.scrollToStep(index);
    }

    scrollToStep(index) {
      const trackTop = this.track.getBoundingClientRect().top + window.scrollY;
      const scrollable = Math.max(1, this.track.offsetHeight - window.innerHeight);
      const progress = (index + 0.5) / this.steps.length;
      const top = trackTop + progress * scrollable;

      this.setActiveStep(index, { force: true });

      this.manualScroll = true;
      window.scrollTo({ top, behavior: 'smooth' });

      window.setTimeout(() => {
        this.manualScroll = false;
        this.updateActiveStep();
      }, 600);
    }
  }

  customElements.define('home-fourth-steps', HomeFourthSteps);
})();
